export const INTERNAL_ERROR_MESSAGE: string = ""
    + "\n" + "Uh-oh, looks like Reliq took a wrong turn!"
    + "\n" + "Don't worry, it's not you-it's us."
    + "\n" + "Please report this at https://github.com/snqre/reliq";